import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { Loading } from "scmp-app/components/common/loading";
import { ContentItemSecondary } from "scmp-app/components/content/content-item-render/variants/secondary";

export const Container = styled.div``;

export const Item = styled(ContentItemSecondary)`
  padding-block: 20px;

  & + & {
    border-block-start: 1px solid #e5e5e5;
  }
`;

export const StyledAdSlot = styled(AdSlot)`
  padding-block-end: 20px;
`;

export const AdSlotWrapper = styled.div`
  ${theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
  }
`;

export const StyledLoading = styled(Loading)`
  padding-block-end: 60px;
`;

export const EmptyLabel = styled.div`
  margin-block-start: 20px;

  color: #666666;
  font-size: 16px;
  line-height: 130%;
`;
